__turbopack_context__.v({
  "darktext": "SplitView-module-scss-module__N5fNEW__darktext",
  "rowSwapped": "SplitView-module-scss-module__N5fNEW__rowSwapped",
  "splitview": "SplitView-module-scss-module__N5fNEW__splitview",
  "splitviewimage": "SplitView-module-scss-module__N5fNEW__splitviewimage",
  "splitviewtext": "SplitView-module-scss-module__N5fNEW__splitviewtext",
  "swapped": "SplitView-module-scss-module__N5fNEW__swapped",
});
